import { ErrorMessage, Field } from "formik";
import AsteriskLabel from "../../Common/AsteriskLabel";

export default function NumberInputBoxDuration({ title, name, placeholder, key, showstar=true }) {
  const handleKeyDown = (e) => {
    const input = e.target.value;

    // Allow control keys
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab" ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    // Prevent decimal point
    if (e.key === ".") {
      e.preventDefault();
      return;
    }

    // Allow only numbers and max 3 digits
    if (/[0-9]/.test(e.key)) {
      if (input.length >= 3) {
        e.preventDefault();
      }
      return;
    }

    // Prevent all other keys
    e.preventDefault();
  };

  const handleChange = (e, form) => {
    const value = e.target.value;

    // Allow empty value
    if (value === "") {
      form.setFieldValue(name, "");
      return;
    }

    // Allow only numbers with max 3 digits
    const regex = /^\d{1,3}$/;
    if (regex.test(value)) {
      form.setFieldValue(name, value);
    }
  };

  return (
    <div key={key} className="form-group">
      <label>
        {title} {showstar && title ? <AsteriskLabel /> : ""}
      </label>
      <Field name={name}>
        {({ field, form }) => (
          <input
            {...field}
            type="text"
            placeholder={placeholder}
            className="form-control"
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(e, form)}
            value={field.value || ""}
          />
        )}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="error"
        style={{ color: "red" }}
      />
    </div>
  );
}
